import AppContext, {IAppContext, IAppV2Context} from "../../../componentsApp/context/AppContext";
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";


export default function FourHundredThree(props: { page: string, fullPage: boolean, setPage: boolean }) {
  
  const appContextV2: IAppV2Context = useContext(AppContext) as IAppV2Context;
  const language: string = appContextV2.appSession.app.language;
  
  useEffect(() => {
    if(props.fullPage) {
      appContextV2.dispatchNavigation({type: "SET_PAGE", value: props.page});
    }
  }, []);
  
  return (
    <>
      <section className={`access-fail-40X__bg-2 ${props.fullPage ? "full-page" : "empty-page"}`}>
        <section className={"access-fail-40X"}>
          <article className={"access-fail-40X__number"}>
            403
          </article>
          <article className={"access-fail-40X__message"}>
            {language === "FR" && <>Il semble que tu n'ai pas accès à cette page.<br/>N'hésite pas à <Link to={"/contact"}>
              <button className={"btn--hollow modern-link"}>nous prévenir</button>
            </Link> si ce comportement n'est pas normal.</>}
            {language === "EN" && <>It seems you can't access this part of the website.<br/>Don't hesitate to <Link to={"/contact"}>
              <button className={"btn--hollow modern-link"}>tell us</button>
            </Link> if this is not expected.</>}
          </article>
        </section>
      </section>
    </>
  );
}